import React from 'react'
import PropTypes from 'prop-types'
import Isvg from 'react-inlinesvg'

const SVGIcon = ({ icon, ...props }) => {
  return (
    <Isvg src={icon} {...props} />
  )
}

SVGIcon.propTypes = {
  icon: PropTypes.string
}

export default SVGIcon



// WEBPACK FOOTER //
// ./src/components/svgIcon.jsx